import React from "react";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

/**
 * Shows the user's full name (first and last) from Redux profile.
 */
export default function UserProfileSidebarFullName() {
  const { profile } = useSelector((state) => state.profile);
  if (!profile) return null;
  const { first_name = "", last_name = "" } = profile;
  const fullName = `${first_name} ${last_name}`.trim();
  return (
    <Typography
      variant="subtitle1"
      color="#fff"
      align="center"
      sx={{ fontWeight: 600, mb: 0.5 }}
    >
      {fullName}
    </Typography>
  );
}
